import React from 'react';
import { OFFER_ANCHOR } from '../data/electrical';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  sub?: string;
  /** Use 'light' when the button sits on a dark background. */
  subTone?: 'dark' | 'light';
  /** Defaults to the purchase block; the offer block passes the checkout URL. */
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  sub,
  subTone = 'dark',
  href = OFFER_ANCHOR
}: CTAButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-30" data-mp="2p09mk3z8s386">
      <a href={href} className="block w-full rounded-lg bg-volt px-4 py-3 text-center font-head text-base font-extrabold uppercase leading-tight tracking-wide text-navy shadow-[0_5px_0_0_#C79400] transition-transform duration-150 ease-soft hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-volt sm:text-lg" data-id="element-31" data-mp="2ozi29pb3hrx7">
        {children}
      </a>
      {sub && <p className={`mt-1 text-center text-[11px] font-semibold sm:text-xs ${subTone === 'light' ? 'text-white/80' : 'text-carbon/70'}`} data-id="element-32" data-mp="198wj34y1fa2h">
          {sub}
        </p>}
    </div>;
}